export default {
    'CUSTOMISATION.FEEDBACK': 'Retour sur le rendez-vous dans Calizy Pro',
    'CUSTOMISATION.UNAVAILABILITY': 'Créer des indisponibilités dans Calizy Pro',
};
